import "./styles.css";
import { Outlet, useLocation, useParams } from "react-router-dom";
import { memo } from "react";
import { useSelector } from "react-redux";
import { MainLayoutV2 } from "../../components/main-layout-v2/main-layout-v2";
import { MainNavigation } from "../../components/main-navigation/main-navigation";
import { Sidebar } from "../../components/sidebar/sidebar";
import { selectUser } from "../../store/slices/user";
import UnifiedAiButton from "../../components/UnifiedAiButton/UnifiedAiButton";
import { useAccess } from "../../common/utils/usePermissions";
import { canOpen, visibleItems } from "../../common/permissions/screens";

const Reports = memo(() => {
  const { pathname } = useLocation();
  const { projectCode } = useParams();
  const currentUser = useSelector(selectUser);
  const access = useAccess();

  // LF360-2024: each screen shown to whoever may open it
  // (common/permissions/screens.js).
  const fullNavigation = [
    {
      label: "Monitoring",
      type: "group",
      children: [
        {
          key: "/analytics/monitoring/scenarios",
          label: "Scenarios",
        },
        {
          key: "/analytics/monitoring/tasks",
          label: "Tasks",
        },
        {
          key: "/analytics/monitoring/onboardings",
          label: "Onboarding",
        },
        {
          key: "/analytics/monitoring/articles",
          label: "Articles",
        },
        {
          key: "/analytics/usage",
          label: "Usage",
        },
      ],
    },
    {
      label: "Audit trail",
      type: "group",
      children: [
        {
          key: "/analytics/audit-trail/subjects",
          label: "Subjects",
          default: pathname === "/analytics" || pathname === "/analytics/audit-trail/subjects",
        },
        { key: "/analytics/audit-trail/scenarios", label: "Scenarios" },
        { key: "/analytics/audit-trail/users", label: "Users" },
        { key: "/analytics/audit-trail/chats", label: "AI chatbot" },
      ],
    },
    {
      label: "Data reports",
      type: "group",
      children: [
        {
          key: "/analytics/reports/surveys",
          label: "Surveys",
          default: pathname === "/analytics" || pathname === "/analytics/reports/surveys",
        },
        {
          key: "/analytics/reports/onboardings",
          label: "Onboardings",
          default: pathname === "/analytics/reports/onboardings",
        },
      ],
    },
    {
      label: "AI Assistant",
      type: "group",
      children: [
        {
          key: "/analytics/ai-assistant",
          label: "LifeFit360 AI ✨",
          "data-testid": "nav-ai-assistant",
        }
      ],
    },
  ];

  const navigation = visibleItems(access, fullNavigation);

  // Hide AI button when on the full-screen AI assistant page
  const isAiAssistantRoute = pathname.includes('/analytics/ai-assistant');

  return (
    <MainLayoutV2>
      <MainNavigation />
      {/* Hide sidebar on AI assistant full-screen page */}
      {!isAiAssistantRoute && (
        <Sidebar
          title={"Analytics"}
          items={navigation}
        />
      )}
      <Outlet />
      {currentUser && currentUser.id && !isAiAssistantRoute &&
        canOpen(access, "/analytics/ai-assistant") && (
        <UnifiedAiButton
          userId={currentUser.id}
          currentRoute={pathname}
          projectId={projectCode}
          contextData={null}
        />
      )}
    </MainLayoutV2>
  );
});

export default Reports;
